namespace aq.utilityBudgets {
    export const seriesColors = {
        red: '#E70F28',
        green: '#7ACD46',
        weather: '#D9DF20'
    };
}
